import { render, staticRenderFns } from "./ClinicalDraftDialog.vue?vue&type=template&id=4a41299f&scoped=true"
import script from "./ClinicalDraftDialog.vue?vue&type=script&lang=js"
export * from "./ClinicalDraftDialog.vue?vue&type=script&lang=js"
import style0 from "./ClinicalDraftDialog.vue?vue&type=style&index=0&id=4a41299f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41299f",
  null
  
)

export default component.exports